import CampaignRecordsListItem from './CampaignRecordsListItem';
import CampaignRecordsSearchPanel from './CampaignRecordsSearchPanel';
import RecordActionButtons from './RecordActionButtons';
import ShIconWithDescription from '@/components/Helpers/ShIconWithDescription';
import SurveyPopover from '@/components/Surveys/SurveyPopover';
import EmptyList from '@/components/Common/EmptyList';
import ProgressBar from '../../../Dashboard/ProgressBar';
import { hDeepCopy } from '@/utils/helpers';
import moment from 'moment';

// @vue/component
export default {
  name: 'CampaignRecordsList',

  components: {
    CampaignRecordsListItem,
    CampaignRecordsSearchPanel,
    EmptyList,
    ProgressBar,
    SurveyPopover,
    RecordActionButtons,
    ShIconWithDescription
  },

  props: {
    projectsList: {
      type: Array,
      default: () => [],
    },
    agentsBelongsToUserList: {
      type: Array,
      default: () => [],
    },
    campaignUuid: {
      type: String,
      default: ''
    },
    projectUuid: {
      type: String,
      default: '',
    },
    isParentComponentLoaded: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      filterBy: {
        number: '',
        result: '',
      },
      isSending: false,
      isCurrentCallVisible: false,
      isSurveyPopoverVisible: false,
      selectedSurvey: '',
    };
  },

  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    itemsPerPage: {
      handler() {
        this.currentPage = 1;
      }
    },
  },

  computed: {
    campaignRecordsList() {
      return this.$store.getters['campaign/list'];
    },
    campaignRecordsFilteredList() {
      let filteredRecordsList = hDeepCopy(this.campaignRecordsList.records)
      filteredRecordsList = filteredRecordsList.filter(item => item.count_done < item.count_try);
      if (this.filterBy.number) {
        filteredRecordsList = filteredRecordsList.filter(item => item.num_for_call.includes(this.filterBy.number));
      }
      if (this.filterBy.result) {
        filteredRecordsList = filteredRecordsList.filter(item => item.result === this.filterBy.result);
      }
      return filteredRecordsList;
    },
    campaignRecordsToRenderPerPage() {
      return this.campaignRecordsFilteredList.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
    },
    statusAndRecordDictionary() {
      return this.$store.getters['campaign/statusAndRecordDictionary'];
    },
    isEmpty() {
      return this.campaignRecordsFilteredList.length === 0 || !this.isParentComponentLoaded;
    },
    isSinglePage() {
      return this.campaignRecordsFilteredList.length <= this.itemsPerPage;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaign/getDetails',
      ]);
    },
    isDisabled() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaigns/getDetails',
      ]);
    },
    isTakingNewData() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaign/getDetails',
      ]);
    },
    currentCallDetails() {
      return this.$store.getters['campaign/currentCallDetails'];
    },
    currentCallingAgentUuid() {
      return this.$store.getters['user/agent/callingAgentDetails']?.details?.uuid;
    },
    currentCallSurvey() {
      return this.$store.getters['campaign/currentCallSurvey'];
    }
  },
  async created() {
    await this.$store.dispatch('campaign/getDetails', this.campaignUuid);
  },
  methods: {
    fetchRecords() {
      this.$store.dispatch('campaign/getDetails', this.campaignUuid);
    },
    changeFilterBy(value) {
      this.filterBy = value
    },
    handleChangePage(page) {
      this.currentPage = page;
    },
    async checkIfAnyAgentIsCalling() {
      await this.$store.dispatch('user/agent/getAgentsBelongsToUserList');
      const currentTalkingAgent = this.agentsBelongsToUserList.filter(agent => agent.is_talking === true);
      if (currentTalkingAgent.length > 0) {
        await this.$store.commit('user/agent/SET_CALLING_AGENT_DETAILS', currentTalkingAgent[0]);
      } else {
        await this.$store.commit('user/agent/SET_CALLING_AGENT_DETAILS', {});
      }
    },
    async handleGetCurrentCallDetails() {
      await this.checkIfAnyAgentIsCalling();
      if (this.currentCallingAgentUuid) {
        await this.$store.dispatch('campaign/getCurrentCallDetails', this.currentCallingAgentUuid);
        if (this.currentCallDetails.length > 0) {
          await this.$store.dispatch('campaign/getSurveyForCurrentCall', this.currentCallDetails[0].wh1_uuid);
          this.selectedSurvey = this.currentCallSurvey[0]._uuid_survey;
        }
      } else {
        this.$store.commit('campaign/FILL_CURRENT_CALL_DETAILS', []);
      }
      this.isCurrentCallVisible = true;
    },
    refreshRecordsList() {
      this.$emit('refreshList');
    },
    async hideSurveyModal() {
      this.isSurveyPopoverVisible = false;
      await this.$store.dispatch('campaign/getSurveyForCurrentCall', this.currentCallDetails[0].wh1_uuid);
    },
  },
};
